<div id="mainComponentContainer">
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="mb-5 w-100" v-show="!loading">
                    <button class="btn btn-primary float-right " @click="onExportToCsvClick" id="btnExportCustomerCsv">Export CSV</button>
                </div>
                <div v-show="!loading">
                    <data-table :headings="customerHeadings" :data="customers" :hasActions="true"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @pagingUpdated="onPagingUpdated"
                                @actionClicked="onCustomerActionClicked" @filterSearchClicked="onFilterSearchClicked">
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <from-date-to-date-pickers  :title="'Date Created'"
                                                                    :fromDate="filter.fromDateCreated"
                                                                    :toDate="filter.toDateCreated"
                                                                    :elementId="'customerDateFilter'"
                                                                    :dateFormat="'dd/MM/yyyy'"
                                                                    @clearDatePicker="onDateFilterClearClick"
                                                                    @fromDateSelected="onFromDateCreatedSelect"
                                                                    @toDateSelected="onToDateCreatedSelect"></from-date-to-date-pickers>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="">
                                            <label for="genderSelect" class="genderFilterLabel">
                                                Gender
                                            </label>
                                            <bootstrap-select :selectOptions="gendersFilter" :selectedOption="filter.gender" :elementId="'genderFilterSelect'"
                                                              :returnSelectedOptionText="true"
                                                              @changeSelect="onGenderFilterSelect"></bootstrap-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="pr-3">
                                    <active-inactive-radio-buttons :activeInactiveKey="filter.activeOrInactiveItems"
                                                                   :componentId="'customerFilterRadioButtons'"
                                                                   @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                                </div>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <mark-as-active-inactive-modal
                :heading="customerMarkAsActiveInactiveModal.heading"
                :modalId="customerMarkAsActiveInactiveModal.modalId"
                :isSaving="customerMarkAsActiveInactiveModal.isSaving"
                :showModal="customerMarkAsActiveInactiveModal.showModal"
                :isActive="customerMarkAsActiveInactiveModal.isActive"
                @closeClicked="customerMarkAsActiveInactiveModal.showModal = false"
                @saveButtonClicked="onMarkAsActiveInactiveSaveClick"></mark-as-active-inactive-modal>
    
    <modal-form
        :heading="customerAddEditFormModal.heading"
        :modalId="customerAddEditFormModal.modalId"
        :isSaving="customerAddEditFormModal.isSaving"
        :showModal="customerAddEditFormModal.showModal"
        @closeClicked="onEditCustomerModalCloseClick"
        @saveButtonClicked="onEditCustomerModalSaveClick">
        <template #form>
            <form>
                <div class="form-group">
                    <label for="cardBarcodeNumberInput">
                        Card Barcode Number
                    </label>
                    <div class="text-danger" v-if="customer.cardBarcodeNumber.hasError">
                        {{customer.cardBarcodeNumber.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="cardBarcodeNumberInput" v-model="customer.cardBarcodeNumber.value">
                </div>
                <div class="form-group">
                    <label for="firstNameInput">
                        First Name
                    </label>
                    <div class="text-danger" v-if="customer.firstName.hasError">
                        {{customer.firstName.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="firstNameInput" v-model="customer.firstName.value">
                </div>
                <div class="form-group">
                    <label for="lastNameInput">
                        Last Name
                    </label>
                    <div class="text-danger" v-if="customer.lastName.hasError">
                        {{customer.lastName.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="lastNameInput" v-model="customer.lastName.value">
                </div>
                <div class="form-group">
                    <label for="emailAddressInput">
                        Email Address
                    </label>
                    <div class="text-danger" v-if="customer.emailAddress.hasError">
                        {{customer.emailAddress.errorMessage}}
                    </div>
                    <input type="email" class="form-control" id="emailAddressInput" v-model="customer.emailAddress.value">
                </div>
                <div class="form-group">
                    <label for="mobileNumberInput">
                        Mobile Number
                    </label>
                    <div class="text-danger" v-if="customer.mobileNumber.hasError">
                        {{customer.mobileNumber.errorMessage}}
                    </div>
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text">+</span>
                        </div>
                        <input type="tel" class="form-control" id="mobileNumberInput" v-model="customer.mobileNumber.value" @input="onMobileNumberInput">
                    </div>
                   
<!--                    <input class="form-control" id="mobileNumberInput" v-model="customer.mobileNumber.value" @input="onMobileNumberInput">-->
                </div>
                <div class="form-group">
                    <label for="dateOfBirthInput">
                        Date of Birth
                    </label>
                    <div class="text-danger" v-if="customer.dateOfBirth.hasError">
                        {{customer.dateOfBirth.errorMessage}}
                    </div>
                    <date-picker :format="'dd/MM/yyyy'" :elementId="'activeFromDatePicker'" :date="customer.dateOfBirth.value"
                                 :initialiseDate="initialiseActiveFromDate"
                                 @dateChange="onDateOfBirthSelect"></date-picker>
                </div>
                <div class="form-group">
                    <label for="genderSelect">
                        Gender
                    </label>
                    <div class="text-danger" v-if="customer.gender.hasError">
                        {{customer.gender.errorMessage}}
                    </div>
                    <bootstrap-select :selectOptions="genders" :selectedOption="customer.gender.value" :elementId="'genderSelect'"
                                      :returnSelectedOptionText="true"
                                      @changeSelect="onGenderSelect"></bootstrap-select>
                </div>
<!--                <h4>Place of Residence</h4>-->
<!--                <div class="form-group">-->
<!--                    <label for="streetInput">-->
<!--                        Street-->
<!--                    </label>-->
<!--                    <div class="text-danger" v-if="customer.placeOfResidence.street.hasError">-->
<!--                        {{customer.placeOfResidence.street.errorMessage}}-->
<!--                    </div>-->
<!--                    <input type="text" class="form-control" id="streetInput" v-model="customer.placeOfResidence.street.value">-->
<!--                </div>-->
<!--                <div class="form-group">-->
<!--                    <label for="suburbInput">-->
<!--                        Suburb-->
<!--                    </label>-->
<!--                    <div class="text-danger" v-if="customer.placeOfResidence.suburb.hasError">-->
<!--                        {{customer.placeOfResidence.suburb.errorMessage}}-->
<!--                    </div>-->
<!--                    <input type="text" class="form-control" id="suburbInput" v-model="customer.placeOfResidence.suburb.value">-->
<!--                </div>-->
<!--                <div class="form-group">-->
<!--                    <label for="cityInput">-->
<!--                        City-->
<!--                    </label>-->
<!--                    <div class="text-danger" v-if="customer.placeOfResidence.city.hasError">-->
<!--                        {{customer.placeOfResidence.city.errorMessage}}-->
<!--                    </div>-->
<!--                    <input type="text" class="form-control" id="cityInput" v-model="customer.placeOfResidence.city.value">-->
<!--                </div>-->
                <div class="form-group">
                    <label for="provinceInput">
                        Province
                    </label>
                    <div class="text-danger" v-if="customer.placeOfResidence.province.hasError">
                        {{customer.placeOfResidence.province.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="provinceInput" v-model="customer.placeOfResidence.province.value">
                </div>
<!--                <div class="form-group">-->
<!--                    <label for="postalCodeInput">-->
<!--                        Postal Code-->
<!--                    </label>-->
<!--                    <div class="text-danger" v-if="customer.placeOfResidence.postalCode.hasError">-->
<!--                        {{customer.placeOfResidence.postalCode.errorMessage}}-->
<!--                    </div>-->
<!--                    <input type="text" class="form-control" id="postalCodeInput" v-model="customer.placeOfResidence.postalCode.value">-->
<!--                </div>-->
            </form>
        </template>
    </modal-form>
    
    <confirmation-modal
        :elementId="deactivateCardModal.modalId"
        :heading="deactivateCardModal.heading"
        :message="deactivateCardModal.message"
        :showModal="deactivateCardModal.showModal"
        :loading="deactivateCardModal.isSaving"
        @actionConfirmed="onActionConfirmed"></confirmation-modal>

    <modal-form
            :heading="issueNewCardModal.heading"
            :modalId="issueNewCardModal.modalId"
            :isSaving="issueNewCardModal.isSaving"
            :showModal="issueNewCardModal.showModal"
            @closeClicked="onIssueNewCardModalCloseClick"
            @saveButtonClicked="onIssueNewCardModalSaveClick">
        <template #form>
            <form>
                <div class="form-group">
                    <label for="cardBarcodeNumberNewInput">
                        Card Barcode Number
                    </label>
                    <div class="text-danger" v-if="issueNewCardModal.cardBarcodeNumber.hasError">
                        {{issueNewCardModal.cardBarcodeNumber.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="cardBarcodeNumberNewInput" v-model="issueNewCardModal.cardBarcodeNumber.value">
                </div>
            </form>
        </template>
    </modal-form>
</div>
